export default "__VITE_ASSET__CJMoFSN5__"